import ServiceTemplate from '@/components/ServiceTemplate';

export default function SCorporation() {
  const data = {
    title: 'S Corporation Formation',
    subtitle: 'Combine corporate protection with pass-through taxation through S Corporation status.',
    overviewTitle: 'Why Choose an S Corporation?',
    overviewImage: 'https://images.unsplash.com/photo-1709715357520-5e1047a2b691',
    description: [
      'An S Corporation is a special tax designation that provides the liability protection of a corporation with the tax benefits of a partnership. S Corps avoid double taxation by passing income directly to shareholders.',
      'S Corporations are ideal for profitable businesses seeking tax savings while maintaining corporate liability protection. Shareholders report their share of business income on personal tax returns.',
      'Our S Corporation service handles both state incorporation and IRS Form 2553 filing to establish S Corporation tax status with comprehensive guidance throughout the process.'
    ],
    benefits: [
      { title: 'Pass-Through Taxation', description: 'Avoid double taxation with income passed to shareholders.' },
      { title: 'Self-Employment Tax Savings', description: 'Reduce SE tax on distributed profits.' },
      { title: 'Liability Protection', description: 'Corporate shield protects personal assets.' },
      { title: 'Credibility', description: 'Corporate structure enhances business credibility.' },
      { title: 'Easy Transfer', description: 'Transfer ownership through stock sales.' },
      { title: 'Perpetual Existence', description: 'Corporation continues beyond owner changes.' }
    ],
    process: [
      { title: 'Discovery & Planning', description: 'Comprehensive assessment of your needs and strategic planning for optimal outcomes.' },
      { title: 'Documentation & Filing', description: 'Complete preparation and filing of all required documents with appropriate authorities.' },
      { title: 'Compliance & Support', description: 'Ongoing compliance monitoring, support, and strategic guidance as your needs evolve.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'Who can be an S Corp shareholder?', answer: 'Only U.S. citizens and residents, certain trusts, and estates can be shareholders. Corporations and partnerships cannot.' },
      { question: 'How many shareholders are allowed?', answer: 'S Corporations are limited to 100 shareholders, all of whom must be eligible individuals.' },
      { question: 'When must I file for S Corp status?', answer: 'Form 2553 must be filed within 2 months and 15 days of the start of the tax year or by March 15 for existing corporations.' },
      { question: 'Can I have multiple classes of stock?', answer: 'S Corporations can only have one class of stock, though voting rights can differ.' },
      { question: 'What is reasonable compensation?', answer: 'S Corp owner-employees must pay themselves reasonable salaries subject to payroll tax, with remaining profits distributed tax-free.' },
      { question: 'Can I convert my LLC to S Corp?', answer: 'Yes, LLCs can elect S Corporation tax treatment without changing their legal structure.' },
      { question: 'What are ongoing requirements?', answer: 'Annual reports, corporate meetings, proper payroll, and maintaining S Corp eligibility requirements.' },
      { question: 'Will S Corp status save me money?', answer: 'For profitable businesses, S Corp status often provides significant tax savings through reduced self-employment taxes.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
